import React from 'react';
import { Users, BookOpen } from 'lucide-react';

const ClassSubjectItemLoad = () => {
  return (
    <div className="bg-white rounded-xl shadow-lg p-8">
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Users className="text-blue-600" size={32} />
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Class Subject Item Load</h3>
          <p className="text-gray-600">此功能正在開發中 (This feature is under development)</p>
        </div>
      </div>
    </div>
  );
};

export default ClassSubjectItemLoad;